import { combineReducers } from 'redux';
import counter from './counterReducer';
import order from './orderReducer';
export default combineReducers({
    counter,
    order
})